import { render, staticRenderFns } from "./ShokurekishoJobSummaryCard.vue?vue&type=template&id=227e8f1c&scoped=true"
import script from "./ShokurekishoJobSummaryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoJobSummaryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoJobSummaryCard.vue?vue&type=style&index=0&id=227e8f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e8f1c",
  null
  
)

export default component.exports